// Zeus (sa page, son panneau, ses cartes, ses projets, son partage) et les
// conversations (la page, le dock, la fenêtre d'une conversation).
export default {
  sousTitre: 'L’assistant d’Orion',
  nouvelleConversation: 'Nouvelle conversation',
  rechercher: 'Rechercher',
  rechercherConversation: 'Rechercher une conversation',
  colonne: { projets: 'Projets', taches: 'Tâches', etudes: 'Études', epinglees: 'Épinglées', recentes: 'Récentes', epingler: 'Épingler « {titre} »', desepingler: 'Désépingler « {titre} »', chercherPartout: 'Chercher dans vos conversations', chercher: 'Rechercher', aucunProjet: 'Aucun projet pour l’instant : un projet range des conversations et des documents, avec une consigne que Zeus lit dans chacune.', nbConversations: 'aucune conversation | 1 conversation | {n} conversations' },
  etudes: { nouvelle: 'Nouvelle étude', vide: 'Vos études apparaîtront ici. Demandez-en une à Zeus, ou posez-la vous-même.', enCours: 'En cours', echec: 'Arrêtée' },
  projets: 'Projets',
  nouveauProjet: 'Nouveau projet',
  nomProjet: 'Nom du projet',
  nomNouveauProjet: 'Nom du nouveau projet',
  vosConversations: 'Vos conversations',
  lecture: 'Lecture…',
  apparaitront: 'Vos conversations avec Zeus apparaîtront ici.',
  aucuneCorrespond: 'Aucune ne correspond.',
  nouveauTitre: 'Nouveau titre',
  partageeEquipe: 'Partagée à l’équipe',
  partageePersonnes: 'Partagée à des personnes choisies',
  renommer: 'Renommer : {titre}',
  confirmerEffacement: 'Confirmer l’effacement : {titre}',
  effacerTitre: 'Effacer : {titre}',
  partageesAvecVous: 'Partagées avec vous',
  unMembre: 'Un membre de l’équipe',
  rangerProjet: 'Ranger dans un projet',
  aucunProjet: 'Aucun projet',
  imaginer: 'Que voulez-vous imaginer ?',
  aRemarque: 'Zeus a remarqué',
  seRelit: 'La conversation se relit…',
  vous: 'Vous',
  reflechit: 'Zeus réfléchit…',
  reflechitNom: '{nom} réfléchit…',
  cartes: {
    creerFormat: 'Créer ce format',
    creerFormatMessage: 'Crée le format « {titre} »',
    eprouverTitres: 'Éprouver ces titres',
    eprouverTitre: 'Éprouver ce titre',
    comparables: 'Les programmes comparables',
    programme: 'Programme',
    diffuse: 'Diffusé',
    partAudience: 'Part d’audience',
    telespectateurs: 'Téléspectateurs',
  },
  panneau: {
    partagee: 'Partagée',
    pleinePage: 'Pleine page',
    reduire: 'Réduire',
    fermer: 'Fermer',
  },
  partage: {
    prive: 'Privée',
    equipe: 'Toute l’équipe',
    personnes: 'Des personnes choisies',
    partageEquipe: 'Partagé à l’équipe',
    partageAvec: 'Partagé avec {n} personne | Partagé avec {n} personne | Partagé avec {n} personnes',
    partager: 'Partager',
    auMoinsUne: 'Choisissez au moins une personne.',
    avecQui: 'Avec qui',
    rechercherPersonne: 'Rechercher une personne',
    lectureEquipe: 'Lecture de l’équipe…',
    personneDautre: 'Personne d’autre dans votre équipe pour l’instant.',
    annuler: 'Annuler',
    enregistrer: 'Enregistrer',
  },
  projet: {
    seLit: 'Le projet se lit…',
    nom: 'Nom du projet',
    renommer: 'Renommer le projet',
    confirmer: 'Confirmer',
    effacer: 'Effacer',
    consigne: 'La consigne de Zeus',
    gardee: 'Gardée',
    consignePlaceholder: 'Ce que Zeus doit savoir pour ce projet : le programme, le public visé, le ton, ce qu’il faut éviter…',
    consigneAria: 'La consigne de Zeus pour ce projet',
    documents: 'Les documents du projet',
    envoi: 'Envoi…',
    deposer: 'Déposer un fichier',
    coller: 'Coller un texte',
    sonTitre: 'Son titre',
    titreTexte: 'Titre du texte',
    textePlaceholder: 'Le texte à garder dans le projet',
    texteAria: 'Le texte',
    annuler: 'Annuler',
    garder: 'Garder ce texte',
    aucunDocument: 'Aucun document pour l’instant.',
    illisible: 'Illisible',
    lectureEnCours: 'Lecture en cours…',
    retirer: 'Retirer : {titre}',
    conversations: 'Les conversations du projet',
    aucuneConversation: 'Aucune conversation pour l’instant.',
  },
  saisie: {
    prepare: 'Une réponse se prépare…',
    demandez: 'Demandez à Zeus…',
    aria: 'Votre message à Zeus',
    demandezNom: 'Demandez à {nom}…',
    ariaNom: 'Votre message à {nom}',
    envoyer: 'Envoyer',
  },
  actions: {
    formatCree: 'Format créé : « {titre} »',
    ficheCompletee: 'Fiche complétée : « {titre} »',
    ficheCompleteeChamps: 'Fiche complétée : « {titre} » ({champs})',
    sonarPrepare: 'Question préparée : « {question} »',
    panelEtude: 'Le panel de l’étude : « {libelle} »',
    ouvrir: 'Ouvrir',
    ouvrirSonar: 'Ouvrir le Sonar',
    ouvrirExplorer: 'Ouvrir Explorer',
    interroger: 'Interroger',
    tacheProposee: 'Tâche proposée : « {titre} », {cadence}',
    voirTache: 'Voir et activer',
  },
  voix: {
    parler: 'Parler à Zeus',
    arreter: 'Arrêter',
    vous: 'Vous',
    etat: {
      arret: 'Arrêtée',
      connexion: 'Connexion…',
      ecoute: 'Je vous écoute',
      parle: 'Zeus parle (coupez-le quand vous voulez)',
      cherche: 'Zeus regarde dans Orion…',
      erreur: 'Conversation parlée interrompue',
    },
  },
  champs: {
    titre: 'le titre',
    logline: 'la logline',
    promesse: 'la promesse',
    genre: 'le genre',
    diffuseur: 'le diffuseur',
    case_horaire: 'la case',
    cible: 'la cible',
    cibles: 'les cibles',
  },
  questionTitre: 'Le titre {titre} vous donne-t-il envie de regarder ce programme ?',
  questionTitres: 'Lequel de ces titres vous donne le plus envie de regarder ce programme : {liste} ou {dernier} ?',
  guillemets: '« {x} »',
  departs: {
    nouveauFormat: 'J’ai un nouveau format : aide-moi à lui trouver un titre',
    samedi: 'Qu’est-ce qui marche le samedi soir chez les 25-49 ans ?',
    monte: 'Qu’est-ce qui monte sur mes territoires cette semaine ?',
    rendezVous: 'Quels rendez-vous arrivent sur mes territoires ?',
    sonar: 'Que retenir de notre dernière étude ?',
    dossiers: 'Où en sont mes dossiers ?',
    jeunes: 'Qu’est-ce qui monte en ce moment chez les 15-34 ans ?',
  },
  nombre: {
    pc: '{v} %',
    millions: '{v} M',
  },
  conversations: {
    titre: 'Conversations',
    sousTitre: 'Toutes vos conversations, à relire ou à reprendre',
    toutes: 'Toutes',
    genres: {
      sonar: 'Panel d’une étude',
      persona: 'Persona d’une audience',
      marque: 'Persona d’une marque',
      jumeau: 'Jumeau d’un dossier',
      zeus: 'Zeus',
      polis: 'Électeurs d’une vague',
    },
    periodes: {
      aujourdhui: 'Aujourd’hui',
      hier: 'Hier',
      semaine: 'Cette semaine',
      mois: 'Ce mois-ci',
      avant: 'Plus tôt',
    },
    seLisent: 'Les conversations se lisent…',
    aucune: 'Aucune conversation pour l’instant.',
    aucuneCorrespond: 'Aucune conversation ne correspond.',
    partageeEquipe: 'Partagée à l’équipe',
    partageeAvec: 'Partagée avec {n} personne | Partagée avec {n} personne | Partagée avec {n} personnes',
    reprendre: 'Reprendre',
    pageOrigine: 'Page d’origine',
    confirmer: 'Confirmer',
    effacer: 'Effacer',
    aucunMessage: 'Aucun message.',
    reponseSePrepare: 'Une réponse se prépare.',
    seLit: 'La conversation se lit…',
    choisir: 'Choisissez une conversation à relire.',
    reduireTitre: 'Réduire : {titre}',
    ouvrirTitre: 'Ouvrir : {titre}',
    fermerTitre: 'Fermer : {titre}',
    nouvelle: 'Nouvelle conversation',
    ouvrirOrigine: 'Ouvrir la page d’origine',
    reduire: 'Réduire',
    fermer: 'Fermer',
    toutLePanel: 'Tout le panel',
    territoire: 'Territoire',
    tousTerritoires: 'Tous les territoires',
    jury: 'Le jury',
    envieAvec: 'Envie de regarder avec {jury}',
    leurReponse: 'Leur réponse',
    quelleQueSoit: 'Quelle que soit leur réponse',
    ontRepondu: 'Qui ont répondu « {reponse} »',
    quiAiment: 'Qui aiment',
    quelsQueSoient: 'Quels que soient leurs goûts',
    donnent8: 'Qui donnent 8 ou plus à {nom}',
    pourCommencer: 'Pour commencer',
    panelReflechit: 'Le panel réfléchit…',
    electeursReflechissent: 'Les électeurs réfléchissent…',
    reflechit: '{prenom} réfléchit…',
    posezLeur: 'Posez-leur une question…',
    demandezLui: 'Demandez-lui…',
    envoyer: 'Envoyer',
    cibles: {
      c4plus: '4 ans et plus',
      c4a14: '4-14 ans',
      c15a34: '15-34 ans',
      c25a49: '25-49 ans',
      frda50: 'FRDA-50',
      c50plus: '50 ans et plus',
    },
    segment: {
      cibles: {
        c4plus: 'Les 4 ans et plus',
        c4a14: 'Les 4-14 ans',
        c15a34: 'Les 15-34 ans',
        c25a49: 'Les 25-49 ans',
        frda50: 'Les FRDA-50',
        c50plus: 'Les 50 ans et plus',
      },
      toutLePanel: 'Tout le panel',
      jury: 'qui auraient envie de regarder avec {jury}',
      reponse: 'qui ont répondu « {reponse} »',
      fan: 'qui donnent 8 ou plus à {nom}',
    },
    juryDerniereSaison: 'le jury de la dernière saison',
    questionsSonar: {
      departage1: 'Qu’est-ce qui vous donne envie avec ce jury ?',
      departage2: 'Qui vous manquerait dans ce jury ?',
      departage3: 'Qui remplaceriez-vous, et par qui ?',
      fan1: 'Pourquoi {nom} ?',
      fan2: 'Que savez-vous de {nom} en ce moment ?',
      fan3: 'Et si {nom} n’était pas là ?',
      choix1: 'Qu’est-ce qui a compté le plus dans votre réponse ?',
      choix2: 'Qu’est-ce qui vous ferait changer d’avis ?',
      choix3: 'Qu’en dit-on autour de vous ?',
      defaut1: 'Qu’est-ce qui vous ferait regarder la prochaine saison ?',
      defaut2: 'Quel nom vous ferait zapper ?',
      defaut3: 'Qu’attendez-vous de ce programme ?',
    },
    personaDe: 'Persona de {marque}',
    jumeau: 'Jumeau · {segment}',
  },
}
